import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from './index.module.scss?v=20220705'

function Panel ({ list }) {
    return (
        <div className={`panel ${styles.panel}`}>
            <ol className="option-list">
                {
                    list.map((item, index) => {
                        return (
                            <li  key={index} className="option-item lx-flex-row">
                                {
                                    item.linkedTarget === '_blank'? (
                                        <object>
                                            <a className="panel-inner lx-flex-row" href={item.linkedUrl}>
                                                <span className="panel-title">{ item.name }</span>
                                            </a>
                                        </object>
                                    ):(
                                        <object>
                                            <NavLink exact className="panel-inner lx-flex-row" to={item.linkedUrl} target={item.linkedTarget}>
                                                <span className="panel-title">{ item.name }</span>
                                            </NavLink>
                                        </object>
                                    )
                                }
                            </li>
                        )
                    })
                }
            </ol>
        </div>
    )
}

export default Panel